import React from 'react';
import {BrandDriverMessages, BrandDriverConfigs} from './config';
import './index.scss';
import {FormattedMessage} from 'react-intl';
import {Icon} from '../../common/gutenberg';

export default function SRPBrandDrivers(props) {
  return (
    <div className="SRP__BrandDriversContainer">
      <h4 className="SRP__BrandDriversHeading">
        <FormattedMessage id="SRPBrandDrivers.BrandDriverHeader" defaultMessage="Why sell on StubHub ?" />
      </h4>
      {BrandDriverConfigs.brandDrivers.map(({name, styles}) => (
        <div className="SRP__BrandDrivers" key={name}>
          <div className="SRP__BrandDriversImage">
            <Icon
              title={`${name} icon`}
              desc={`Brand Driver Icon: ${name}`}
              id={name}
              name={name}
              styles={{fill: '#677383', ...styles}}
              className="SRPBrandDrivers_svg"
            />
          </div>
          <div className="SRP__BrandDriversMessage">
            <FormattedMessage {...BrandDriverMessages[name]} />
          </div>
        </div>
      ))}
    </div>
  );
}
